import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type CreateTimeEntryInput,
	createTimeEntry,
	type UpdateTimeEntryInput,
	updateTimeEntry,
} from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { TimeEntry } from "../types";
import { toTimeEntry } from "../utils/map";
import { invalidateAttendance } from "./invalidate-attendance";

export type SaveTimeEntryInput =
	| ({ entryId?: undefined } & CreateTimeEntryInput)
	| ({ entryId: string } & UpdateTimeEntryInput);

export function useSaveTimeEntry() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: async (input: SaveTimeEntryInput): Promise<TimeEntry> => {
			const worksiteId = activeCanteiroId as string;
			if (input.entryId != null) {
				const { entryId, ...update } = input;
				return toTimeEntry(await updateTimeEntry(worksiteId, entryId, update));
			}
			return toTimeEntry(await createTimeEntry(worksiteId, input));
		},
		onSuccess: () => {
			invalidateAttendance(queryClient);
		},
	});
}
